<template>
    <div><!-- 試作準備報表 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>{{ i18n("TentativePreparationReport.TentativePreparationReport") }}</strong>
            </CCardHeader>
            <CCardBody>                
                    <CForm>
                        <div class="CForminline">
                            <div class="factory">
                                <p>{{ i18n("TentativePreparationReport.VendorName") }}：</p>                                
                                <input style="width: 300px;" type="text" v-if="disableCusName_input" :disabled="true" v-model="trialProdQueryParam.customerName">                                                        
                                <Select2 style="width: 300px;" v-if="!disableCusName_input" v-model="trialProdQueryParam.vendorId" :options="memberListFilter()" :settings="{  multiple: false, dropdownAutoWidth : true , width: '100%' ,allowClear:true}" />
                                <p>&emsp;&emsp;{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                <div v-for="(item, key) in factoryList" :key="'factoryType_input_' + key">
                                    <input :disabled ="disableFactory" type="radio" :name="'tpr_FactoryTypeOpt'" v-model="trialProdQueryParam.factoryId" :value="item.factoryId" >{{getFactoryCaption(item.factoryId,item.factoryCaption)}}
                                </div>
                            </div>
                            <div class="name">
                                <p>{{ i18n("TentativePreparationReport.MachineName") }}：</p>
                                <input type="text" maxlength="50" v-model="trialProdQueryParam.roeModel">
                            </div>
                            <div class="date">
                                <p>{{ i18n("TentativePreparationReport.EstablishedDates") }}：</p>
                                <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="trialProdQueryParam.createDateBegin" ></date-picker> ~ <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="trialProdQueryParam.createDateEnd" ></date-picker>
                            </div>
                            <div class="date">
                                <p>{{ i18n("QualityInfo_Vue.RowStatus") }}：</p>
                                <div
                                    v-for="(item, key) in TPRList"
                                    :key="'RowStatus_input_' + key"
                                >
                                    <input
                                    type="radio"
                                    name="caseClosed_input"
                                    v-model="trialProdQueryParam.qualitySearchEnum"
                                    :value="item.statusId"
                                    />{{ item.statusCaption }}
                                </div>
                            </div>
                            <div class="btn_group">
                                <button type="button" class="btn btn-edit mr-2"  @click="trialProdQueryEvent">{{$t('Buttons.Query')}}</button>
                                <button type="button" class="btn btn-success mr-2" @click="trialProdExportEvent">{{$t('Buttons.ExportOrder')}}</button>
                            </div>                            
                        </div>
                    </CForm>                
            </CCardBody>
        </CCard>

        <CCard>
            <CCardBody>
                <div class="table-container">
                    <vue-bootstrap4-table
                        ref="tentativeBs4Table"
                        class=""
                        :rows="rows"
                        :columns="columns"
                        @on-change-query="onChangeQuery"
                        :total-rows="totalCount"
                        :config="config"
                        :classes="classes"
                    >
                        <template v-if="isTw" slot="empty-results"> 查無結果 </template>
                        <template v-if="isTw" slot="pagination-info" slot-scope="props">
                        {{ paginationInfoTwText(props) }}
                        </template>
                        <template slot="T0" slot-scope="props">
                            <el-tooltip class="item" effect="dark" placement="top-start" v-if="props.row.tooltipT0.length>0">
                                <div slot="content" v-for="(list, index) in props.row.tooltipT0" :key="index">
                                    <div v-if="list.itemStatus === 4">{{list.item}} + 未上傳</div>
                                </div>
                                <router-link v-if="isDevelopPhaseLink(props.row.t0Count)" @click.native="goDevelopPhaseEvent(props.row, 'T0')" to="">{{props.row.t0ShowTxt}}</router-link>
                            </el-tooltip>
                            <div v-else>
                                <router-link v-if="isDevelopPhaseLink(props.row.t0Count)" @click.native="goDevelopPhaseEvent(props.row, 'T0')" to="">{{props.row.t0ShowTxt}}</router-link>
                            </div>
                        </template>
                        <template slot="ES" slot-scope="props">
                            <el-tooltip class="item" effect="dark" placement="top-start" v-if="props.row.tooltipES.length>0">
                                <div slot="content" v-for="(list, index) in props.row.tooltipES" :key="index">
                                    <div v-if="list.itemStatus === 4">{{list.item}} + 未上傳</div>
                                </div>
                                <router-link v-if="isDevelopPhaseLink(props.row.esCount)" @click.native="goDevelopPhaseEvent(props.row, 'ES')" to="">{{props.row.esShowTxt}}</router-link>
                            </el-tooltip>
                            <div v-else>
                                <router-link v-if="isDevelopPhaseLink(props.row.esCount)" @click.native="goDevelopPhaseEvent(props.row, 'ES')" to="">{{props.row.esShowTxt}}</router-link>
                            </div>
                        </template>
                        <template slot="CS" slot-scope="props">
                            <el-tooltip class="item" effect="dark" placement="top-start" v-if="props.row.tooltipCS.length>0">
                                <div slot="content" v-for="(list, index) in props.row.tooltipCS" :key="index">
                                    <div v-if="list.itemStatus === 4">{{list.item}} + 未上傳</div>
                                </div>
                                <router-link v-if="isDevelopPhaseLink(props.row.csCount)" @click.native="goDevelopPhaseEvent(props.row, 'CS')" to="">{{props.row.csShowTxt}}</router-link>
                            </el-tooltip>
                            <div v-else>
                                <router-link v-if="isDevelopPhaseLink(props.row.csCount)" @click.native="goDevelopPhaseEvent(props.row, 'CS')" to="">{{props.row.csShowTxt}}</router-link>
                            </div>
                        </template>
                        <template slot="MP" slot-scope="props">
                            <el-tooltip class="item" effect="dark" placement="top-start" v-if="props.row.tooltipMP.length>0">
                                <div slot="content" v-for="(list, index) in props.row.tooltipMP" :key="index">
                                    <div v-if="list.itemStatus === 4">{{list.item}} + 未上傳</div>
                                </div>
                                <router-link v-if="isDevelopPhaseLink(props.row.mpCount)" @click.native="goDevelopPhaseEvent(props.row, 'MP')" to="">{{props.row.mpShowTxt}}</router-link>
                            </el-tooltip>
                            <div v-else>
                                <router-link v-if="isDevelopPhaseLink(props.row.mpCount)" @click.native="goDevelopPhaseEvent(props.row, 'MP')" to="">{{props.row.mpShowTxt}}</router-link>
                            </div>
                        </template>
                    </vue-bootstrap4-table>
                </div>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {            
            factoryList: this.$t('factoryQMList'), //廠別 清單 
            TPRList: this.$t("TPRList"), // 狀態 清單
            trialProdQueryParam: {
                hadQuery : false,
                customerName :'',
                factoryId: '' ,
                roeModel: '', 
                createDateBegin: null, 
                createDateEnd: null,
                qualitySearchEnum :0,
                pageSize: 10,
                pageIndex: 1,
            },

            rows: [],
            totalCount: 0,
            columns: [
                {
                    label: this.i18n("TentativePreparationReport.Factory"),
                    name: "factoryName",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Vendor"),
                    name: "customerName",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Machine"),
                    name: "roeModel",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.ProjectName"),
                    name: "project",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.PartNumber"),
                    name: "partnumber",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.AverageProgress"),
                    name: "finishShowTxt",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Phase"),
                    name: "T0",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Phase"),
                    name: "ES",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Phase"),
                    name: "CS",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Phase"),
                    name: "MP",
                    row_text_alignment: "text-center",
                },
            ],
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                // server_mode: true, // by default false
                per_page: 10, // default 10
                per_page_options: [10, 25, 50],
                global_search: {
                    visibility: false,
                },
            },
            classes: {},
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.factoryList = this.$t('factoryQMList') //廠別 清單
            this.TPRList = this.$t("TPRList") // 狀態 清單

            this.columns = [
                {
                    label: this.i18n("TentativePreparationReport.Factory"),
                    name: "factoryName",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Vendor"),
                    name: "customerName",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Machine"),
                    name: "roeModel",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.ProjectName"),
                    name: "project",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.PartNumber"),
                    name: "partnumber",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.AverageProgress"),
                    name: "finishShowTxt",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Phase"),
                    name: "T0",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Phase"),
                    name: "ES",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Phase"),
                    name: "CS",
                    row_text_alignment: "text-center",
                },
                {
                    label: this.i18n("TentativePreparationReport.Phase"),
                    name: "MP",
                    row_text_alignment: "text-center",
                },
            ]
        },
    },
    methods: {
        trialProdQueryEvent (){
            this.trialProdQueryParam.hadQuery = true;
            this.trialProdQueryParam.pageIndex = 1;
            this.doTrialProdSearch (this.trialProdQueryParam);        
        },

        // 取得 資料
        doTrialProdSearch (param){
            const url = `${this.$apiUrl_Quality}/SearchTrialProd`;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功                   
                    this.setCacheQueryParam('TrialProd_QueryParam' , param);
                    this.getTrialProdCount(param);
                    this.$refs.tentativeBs4Table.page = param.pageIndex;
                    // this.rows = response.data;

                    let tooltipT0 = [];
                    let tooltipES = [];
                    let tooltipCS = [];
                    let tooltipMP = [];

                    this.rows = response.data.map((item) => {
                        
                        if (item.t0Detail) {
                            let itemStatusFour = item.t0Detail.planDtlItemList;
                            tooltipT0 = itemStatusFour.filter((e) => e.itemStatus === 4 && item.developPhase !== 'T0' && e.item !== '使用過機種數(Products using the same material)' && e.item !== '使用過機種數');
                        }
                        if (item.esDetail) {
                            let itemStatusFour = item.esDetail.planDtlItemList;
                            tooltipES = itemStatusFour.filter((e) => e.itemStatus === 4);
                        }
                        if (item.csDetail) {
                            let itemStatusFour = item.csDetail.planDtlItemList;
                            tooltipCS = itemStatusFour.filter((e) => e.itemStatus === 4);
                        }
                        if (item.mpDetail) {
                            let itemStatusFour = item.mpDetail.planDtlItemList;
                            tooltipMP = itemStatusFour.filter((e) => e.itemStatus === 4);
                        }
   
                        return {
                            ...item,
                            tooltipT0: tooltipT0,
                            tooltipES: tooltipES,
                            tooltipCS: tooltipCS,
                            tooltipMP: tooltipMP,
                        };
                    });                
                }                    
            }); 
        },

        // 取得 總筆數
        getTrialProdCount (param){
            const url = `${this.$apiUrl_Quality}/SearchTrialProdCount`;
            this.axios.post(url, param).then((response) => {
                // console.log(response.data);
                this.totalCount = response.data;                 
            });
        },

        // 匯出
        trialProdExportEvent (){
            this.doTrialProdExport(this.trialProdQueryParam)
        },
        doTrialProdExport (param){
            const url = `${this.$apiUrl_Quality}/PrepareSearchTrialProdExport`;
            this.axios.post(url, param).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Quality}/SearchTrialProdExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('trialProdExportExcel',urlExcel);
            })
        },
        isDevelopPhaseLink (v){
            if(v){
                return true;    
            }
            return false;
        },
        goDevelopPhaseEvent (item , phase){
            let trialKeys = '';
            if(phase === 'T0'){
                trialKeys = item.t0key;
            }else if(phase === 'ES'){
                trialKeys = item.eskey;
            }else if(phase === 'CS'){
                trialKeys = item.cskey;
            }else if(phase === 'MP'){
                trialKeys = item.mpkey;
            }
            trialKeys += '\t' + item.vendor;            
            sessionStorage.setItem('trialKeys', trialKeys);
            sessionStorage.setItem('beforePage', 'tentative');
            this.$router.push('information');
            //this.$router.push('tentativepreparationreportinformation');
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },

        // 分頁搜尋
        onChangeQuery(queryParams) {
            // console.log("queryParams", queryParams);
            let back = sessionStorage.getItem('repotback')
            if (this.trialProdQueryParam.hadQuery) {
                this.trialProdQueryParam.pageSize = queryParams.per_page;
                if (back) {
                    // 內頁返回時，用原本 this.trialProdQueryParam 的參數
                    sessionStorage.removeItem('repotback')
                }else {
                    // 使用底下按鈕
                    this.trialProdQueryParam.pageIndex = queryParams.page
                }
                this.doTrialProdSearch (this.trialProdQueryParam); 
            }
        },

        // 分頁中文資訊
        paginationInfoTwText(props) {
            const vm = this;
            let page = vm.$refs.tentativeBs4Table.page;
            let pageCount = props.currentPageRowsLength;

            let startRecNo = 0;
            let endRecNo = 0;

            if (vm.totalCount && vm.totalCount > 0) {
                startRecNo = 1 + (page - 1) * pageCount;
                endRecNo = startRecNo + pageCount - 1;
                if (endRecNo > vm.totalCount) {
                endRecNo = vm.totalCount;
                }
                return `第 ${startRecNo}筆 ~ 第 ${endRecNo}筆資料列(共${props.originalRowsLength}筆)`;
            } else {
                return "無任何資料列";
            }
        },
    },
    computed: {
        ...mapGetters(["lang"])
    },
	mounted() {
        this.getCacheQueryParam('TrialProd_QueryParam' , this.trialProdQueryParam); 
        const userFactoryId= this.userFactoryId;
        if(userFactoryId){
            this.trialProdQueryParam.factoryId = userFactoryId;
        }        
        if(this.isMember){
            const userInfo = this.$userInfo ;
            this.trialProdQueryParam.vendorId = userInfo.vendorId;
            this.trialProdQueryParam.customerName = userInfo.companyName;
        }else{
            this.initMemberQMList();
        }
        // if(this.trialProdQueryParam.hadQuery){
        //     this.trialProdQueryEvent();
        // }
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .name, .factory, .date, .watch, .check {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        // width: 350px;

        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            flex: 1;
            margin: 0 .5rem;
        }
        > div {
            margin: 0 .5rem;
        }        
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}

table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.table th {
    background-color: #303c50;
    color: #fff;
}

/* Tooltip container */
.tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;
    
    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
    visibility: visible;
}
</style>






